.card {
    background: var(--card-background-color);
    border-radius: var(--card-border-radius);
    box-shadow: var(--card-box-shadow);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    width: 100%;
}
